module.exports = __webpack_public_path__ + "img/Template2.eda8bf48.jpg";